import { render } from "./DocumentTypeSelect.vue?vue&type=template&id=1800de54"
import script from "./DocumentTypeSelect.vue?vue&type=script&lang=js"
export * from "./DocumentTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__